<dw-loading [show]="loading" text="Loading reviews"></dw-loading>

<ng-container *ngIf="!loading">
    <div dwRow>
        <div dwCol="6">
            <app-employee-review-card [(employeeReview)]="employeeReview"
                (employeeReviewChange)="updateReview(employeeReview, false)" [ethosUser]="employeeUser">
            </app-employee-review-card>
        </div>
        <div dwCol="6">
            <app-employee-review-card [(employeeReview)]="supervisorReview"
                (employeeReviewChange)="updateReview(supervisorReview, true)" [ethosUser]="supervisorUser">
            </app-employee-review-card>
        </div>
    </div>

    <ng-container *ngIf="showFullReview">

        <div dwRow>
            <div dwCol="12" [formGroup]="formGroup">
                <label class="label">
                    Review Notes <span style="color:red" *ngIf="!formConfig.readOnly">*</span>
                </label>
                <dw-html-edit formControlName="ReviewNotes" *ngIf="!formConfig.readOnly"></dw-html-edit>
                <dw-html-view formControlName="ReviewNotes" *ngIf="formConfig.readOnly"></dw-html-view>
            </div>
            <div dwCol="5" [formGroup]="formGroup" *ngIf="!formConfig.readOnly">
                <label class="label">
                    Show Graph
                </label>
                <dw-yesno formControlName="ShowGraph"></dw-yesno>
            </div>
        </div>

        <div dwRow>
            <div dwCol="12">
                &nbsp;
            </div>
        </div>
        <dw-loading [show]="analysisLoading" text="Performing Review Analysis"></dw-loading>

        <ng-container *ngIf="!analysisLoading">
            <p-tabView *ngIf="!inPrintMode">
                <p-tabPanel header="Evaluation">
                    <div *ngIf="employeeReviewAnalysis?.customQuestions?.length == 0">
                        There were no evaluation questions for this review
                    </div>
                    <div dwRow *ngFor="let customQuestion of employeeReviewAnalysis?.customQuestions">
                        <div dwCol="12">
                            <label class="label">
                                {{customQuestion.question.Question}}
                            </label>
                        </div>
                        <div dwCol="6">
                            {{employeeUser?.PreferredName || employeeUser?.FirstName}} says
                            <div class="answer-text">
                                {{customQuestion.employeeDisplay || 'Not Answered'}}
                            </div>
                        </div>
                        <div dwCol="6">
                            {{supervisorUser?.PreferredName || supervisorUser?.FirstName}} says
                            <div class="answer-text">
                                {{customQuestion.supervisorDisplay || 'Not Answered'}}
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="Hard/Soft Skills">
                    <app-employee-review-skills-grid [employeeReviewAnalysis]="employeeReviewAnalysis"
                        [employeeUser]="employeeUser" [supervisorUser]="supervisorUser">
                    </app-employee-review-skills-grid>
                </p-tabPanel>

                <p-tabPanel header="Graph" *ngIf="formGroup?.get('ShowGraph')?.value">
                    <app-employee-review-chart [employeeReviewAnalysis]="employeeReviewAnalysis"
                        [employeeUser]="employeeUser" [supervisorUser]="supervisorUser"></app-employee-review-chart>
                </p-tabPanel>
            </p-tabView>

            <ng-container *ngIf="inPrintMode">
                <!--StartEvalDetails-->
                <div class="page-container">
                    <div class="pagebreak" *ngIf="employeeReviewAnalysis?.customQuestions?.length > 0">
                        <dw-container>
                            <div header>
                                Evaluation
                            </div>
                            <div body>
                                <div dwRow *ngFor="let customQuestion of employeeReviewAnalysis?.customQuestions">
                                    <div dwCol="12">
                                        <label class="label">
                                            {{customQuestion.question.Question}}
                                        </label>
                                    </div>
                                    <div dwCol="6">
                                        {{employeeUser?.PreferredName || employeeUser?.FirstName}} says
                                        <div class="answer-text">
                                            {{customQuestion.employeeDisplay || 'Not Answered'}}
                                        </div>
                                    </div>
                                    <div dwCol="6">
                                        {{supervisorUser?.PreferredName || supervisorUser?.FirstName}} says
                                        <div class="answer-text">
                                            {{customQuestion.supervisorDisplay || 'Not Answered'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </dw-container>
                    </div>

                    <div class="pagebreak">
                        <dw-container>
                            <div header>
                                Hard/Soft Skills
                            </div>
                            <div body>
                                <app-employee-review-skills-grid [employeeReviewAnalysis]="employeeReviewAnalysis"
                                    [employeeUser]="employeeUser" [supervisorUser]="supervisorUser">
                                </app-employee-review-skills-grid>
                            </div>
                        </dw-container>
                    </div>

                    <div class="pagebreak" *ngIf="formGroup?.get('ShowGraph')?.value">
                        <dw-container>
                            <div header>
                                Graph
                            </div>
                            <div body>
                                <app-employee-review-chart [employeeReviewAnalysis]="employeeReviewAnalysis"
                                    [employeeUser]="employeeUser" [supervisorUser]="supervisorUser">
                                </app-employee-review-chart>
                            </div>
                        </dw-container>
                    </div>
                </div>
                <div class="end-page-container">

                </div>
                <!--EndEvalDetails-->
            </ng-container>

        </ng-container>

    </ng-container>
</ng-container>


